import './CardExpand.css';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { downloadFilePdf } from '../../Services/api-service';
import { useState } from 'react';
import { openInNewTab } from '../../Services/service';
function CardExpandConfirmWidget ({objectDto}) {
    const [listDoc, setListDoc] = useState([ 
        {"title": "Đơn yêu cầu bảo hiểm", "expand": false, "url": "/rule/Đơn YCBH Siple CI 20250320.docx"}, 
        {"title": "Bảng minh họa quyền lợi bảo hiểm", "expand": false, "url": "/rule/250310_BMH - Digital Simple CI - Finalized from LG.docx"}, 
        {"title": "Quy tắc và Điều khoản sản phẩm", "expand": false, "url": "/rule/Quy tắc và Điều khoản.pdf"}]
    );
    const handleOpenPdfFile = (position) =>{
        downloadFilePdf(objectDto, position);
    }
    return(
        listDoc.map((item, index)=> {
            if(index === 2)
                return  <div className="container-card-expand-confirm" key={index} style={{width:'50%'}} onClick={()=>openInNewTab(item.url)}>
                            <div className='card-form'>
                                <label>{item.title}</label>
                                <AddCircleOutlineIcon className='item-form' />
                            </div>
                        </div>
            else 
                return  <div className="container-card-expand-confirm" key={index} style={{width:'50%'}} onClick={()=>handleOpenPdfFile(index + 1)}>
                            <div className='card-form'>
                                <label>{item.title}</label>
                                <AddCircleOutlineIcon className='item-form' />
                            </div>
                        </div>
        })
    );
}
export default CardExpandConfirmWidget;